module.exports = {
    WEATHER_KEY: '8fdd880b8b04c8db5f6f9057f9574229',
    MAP_KEY: 'AIzaSyDMwAvFlbn7_cImUgGCQi3M5edMih17n0k' 
}